import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import api from "@/lib/api";
import { Loader2, Printer, ShieldCheck, BadgeIndianRupee, Clock } from "lucide-react";

const PROMISES = [
    { icon: ShieldCheck, en: "Verified professionals", hi: "सत्यापित प्रोफेशनल" },
    { icon: BadgeIndianRupee, en: "Clear prices, invoice on every job", hi: "साफ़ कीमत, हर काम का बिल" },
    { icon: Clock, en: "CareBack protection after service", hi: "सेवा के बाद CareBack सुरक्षा" },
];

export default function SocietyPoster() {
    const { sid } = useParams();
    const [p, setP] = useState(null);
    useEffect(() => { api.get(`/admin/societies/${sid}/poster`).then((r) => setP(r.data)).catch(() => setP(false)); }, [sid]);
    if (p === null) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div>;
    if (p === false) return <p className="p-10 text-center text-sm text-navy/60" data-testid="poster-not-found">Society not found.</p>;
    const url = `${window.location.origin}/society/${p.code}`;
    return (
        <div className="min-h-screen bg-navy/10 py-6 print:bg-white print:py-0">
            <style>{"@page { size: A4; margin: 0 } @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact } }"}</style>
            <div className="mx-auto mb-4 flex max-w-[210mm] justify-end print:hidden">
                <button data-testid="poster-print-btn" onClick={() => window.print()} className="flex items-center gap-2 rounded-full bg-orange px-5 py-2.5 text-sm font-bold text-white shadow-lg"><Printer size={16} /> Print poster</button>
            </div>
            <div data-testid="society-poster" className="mx-auto flex h-[297mm] w-[210mm] flex-col overflow-hidden bg-white shadow-2xl print:shadow-none">
                <div className="bg-navy px-12 pb-10 pt-10 text-white">
                    <div className="flex items-center gap-3"><img src="/homiie-logo.jpeg" alt="HOMIIE" className="h-14 w-14 rounded-xl" /><span className="font-heading text-3xl font-extrabold">HOMIIE</span></div>
                    <p className="mt-8 text-sm font-bold uppercase tracking-[0.25em] text-orange">Official home-services partner · आधिकारिक होम-सर्विस पार्टनर</p>
                    <h1 data-testid="poster-society-name" className="mt-2 font-heading text-6xl font-extrabold leading-tight">{p.name}</h1>
                    {p.area_name && <p className="mt-1 text-xl text-white/60">{p.area_name}</p>}
                </div>
                <div className="flex items-center gap-8 px-12 py-8">
                    <div className="rounded-3xl bg-orange px-8 py-6 text-white">
                        {p.residents > 0 ? <>
                            <p data-testid="poster-residents" className="font-heading text-7xl font-extrabold leading-none">{p.residents}</p>
                            <p className="mt-2 text-sm font-bold">residents already on HOMIIE</p>
                            <p className="text-sm">निवासी पहले से HOMIIE पर</p>
                        </> : <>
                            <p data-testid="poster-residents" className="font-heading text-3xl font-extrabold leading-tight">Be the first!</p>
                            <p className="mt-2 text-lg font-bold">सबसे पहले जुड़ें!</p>
                        </>}
                    </div>
                    <div className="flex-1">
                        <p className="font-heading text-3xl font-extrabold text-navy">Join your neighbours!</p>
                        <p className="text-2xl font-bold text-navy/70">अपने पड़ोसियों से जुड़ें!</p>
                        {p.deal_discount && <p data-testid="poster-offer" className="mt-4 rounded-2xl border-2 border-dashed border-orange px-4 py-3 text-lg font-bold text-orange">Resident offer: {p.deal_discount}</p>}
                    </div>
                </div>
                <div className="px-12">
                    <p className="text-sm font-bold uppercase tracking-widest text-navy/50">Most booked in your society · आपकी सोसाइटी में सबसे ज़्यादा बुक</p>
                    <div className="mt-3 grid grid-cols-2 gap-3" data-testid="poster-top-services">
                        {p.top_services.map((s, i) => <div key={s} className="flex items-center gap-3 rounded-2xl bg-navy/[0.05] px-5 py-4"><span className="font-heading text-2xl font-extrabold text-orange">{i + 1}</span><span className="text-xl font-bold text-navy">{s}</span></div>)}
                    </div>
                </div>
                <div className="mt-8 flex flex-1 items-center gap-10 border-t-4 border-orange bg-[#FFF7F0] px-12 py-8">
                    <div className="rounded-3xl bg-white p-4 shadow-lg"><QRCodeSVG value={url} size={230} /></div>
                    <div className="flex-1">
                        <p className="font-heading text-4xl font-extrabold text-navy">Scan to join</p>
                        <p className="text-2xl font-bold text-navy/70">स्कैन करें और जुड़ें</p>
                        <p className="mt-2 text-base text-navy/60">Sign up or log in · साइन अप या लॉग इन करें</p>
                        <div className="mt-5 space-y-2.5">
                            {PROMISES.map(({ icon: I, en, hi }) => <p key={en} className="flex items-start gap-2.5 text-base text-navy"><I size={20} className="mt-0.5 shrink-0 text-teal" /><span><b>{en}</b> · {hi}</span></p>)}
                        </div>
                        <p className="mt-5 font-mono text-sm text-navy/50">{url.replace(/^https?:\/\//, "")}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
